import $http from '../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Crear Historial del producto
 * @param payload: company_id, slq_location_id, type, description, file
 * @autor Paul Valencia
 */
export async function createDcrHistoricalImports({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`dcr_historical_imports`, payload);
        return response.data;
    } catch (error) {
        return Promise.reject(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}



/**
 * Crear seguridad de proceso
 * @param payload: company_id, slq_location_id, type, description, file
 * @autor Paul Valencia
 */
export async function getPrDcrHistoricalImports({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`dcr_historical_imports_get_pr`, { params: payload});
        commit('setProducts',response.data.productos)
        return response.data;
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Obtener historial de importación
 * @param payload:
 * @autor Paul Valencia
 */
export async function getDcrHistoricalImports({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`dcr_historical_imports`, {params: {...payload}});
        commit('setDcrHistoricalImpPr', response.data);
    } catch (error) {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Actualizar Historial del producto de importación
 * @param payload
 * @autor Paul Valencia
 */
export async function updateDcrHistoricalImports({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        await $http.patch(`dcr_historical_imports/${payload.id}/update`, payload);
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Eliminar Historial del producto
 * @param payload: company_id, slq_location_id, type, description, file
 * @autor Paul Valencia
 */
export async function destroyDcrHistoricalImports({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        await $http.patch(`dcr_historical_imports_destroy`, payload);
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Obtener Historial componentes
 * @param payload
 * @autor Paul Valencia
 */
export async function getDcrHistoricalComponentPr({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`dcr_historical_component_products`, {params: {...payload}});
        return response.data;
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}



/**
 * Obtener detalle del historial de importación
 * @param payload:
 * @autor Paul Valencia
 */
export async function showDcrHistoricalImports({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`dcr_historical_imports_show`, {params: {...payload}});
        return response.data;
    } catch (error) {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}



/**
 * Descargar importación de productos
 * @param payload
 * @autor Paul Valencia
 */
export async function exportProductsForImport({commit}, data) {
    commit('dashboard/load', true, {root: true});
    await $http({
        url: `dcr_historical_imports_download_format`,
        method: 'POST',
        responseType: 'blob',
        data
    }).then((response) => {
            commit('dashboard/load', false, {root: true});
            window.downloadFile(response.data, `productos_importacion_${data.year_import}`, '.xlsx')
        })
        .catch(async (error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'Error al exportar los productos',
                showConfirmButton: true,
                timer: 5000
            });
        });
}


/*
 * Cargar informacion en Excel
 *
 * @param commit
 * @param params -> { data: formData, actions: {closeModal: this.closeModal, updateList: this.listarFabricantes} }
 * @returns {Promise<void>}
 */
export async function uploadFileWProductsImported({ commit }, payload) {

    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`dcr_historical_import_information`, payload);
        commit('setBackgroundProcess',response.data);
        return response.data;
    } catch (error) {
        return Promise.reject(error.message)
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}



/**
 * Cargar historico procesos en segundo plano
 *
 * @returns {Promise<void>}
 */
export async function loadProccessBackground({ commit, state },payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`dcr_historical_import_load_proccess_background`, {params: payload});
        commit('setBackgroundProcess', response.data)
    } catch (error) {
        return Promise.reject(error.message)
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}



/**
 * Obtener consolidado
 *
 * @returns {Promise<void>}
 */
export async function getConsolidated({ commit, state },payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`dcr_historical_component_products_consolidated`, {params: payload});
        commit('setComponents', response.data.data)
    } catch (error) {
        return Promise.reject(error.message)
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}


/**
 * Obtener detalle de productos consolidado
 *
 * @returns {Promise<void>}
 */
export async function getDetailByComponent({ commit, state },payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`dcr_hist_comp_pr_consolidated_detail`, {params: payload});
        return response.data.data;
    } catch (error) {
        return Promise.reject(error.message)
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}
